import { useUser } from './userContext';
import { hasChatFeaturePermission } from './chatPermissionUtils';

export function useCallPermissions() {
	const { user } = useUser();

	return {
		canStartAudio: hasChatFeaturePermission(user, 'call.audio.start') || hasChatFeaturePermission(user, 'calling'),
		canStartVideo: hasChatFeaturePermission(user, 'call.video.start') || hasChatFeaturePermission(user, 'videoCalling'),
		canStartConference: hasChatFeaturePermission(user, 'call.conference.start'),
		canJoin: hasChatFeaturePermission(user, 'call.join', { defaultValue: true }),
		canInvite: hasChatFeaturePermission(user, 'call.invite', { defaultValue: false }),
		canEndOwn: hasChatFeaturePermission(user, 'call.end.own', { defaultValue: true }),
		canEndAny: hasChatFeaturePermission(user, 'call.end.any', { defaultValue: false }),
		canScreenShare: hasChatFeaturePermission(user, 'call.screenShare', { defaultValue: true }),
		canMuteSelf: hasChatFeaturePermission(user, 'call.mute.self', { defaultValue: true }),
		canMuteOthers: hasChatFeaturePermission(user, 'call.mute.others', { defaultValue: false }),
		canRemoveParticipant: hasChatFeaturePermission(user, 'call.removeParticipant', { defaultValue: false }),
		canViewHistory: hasChatFeaturePermission(user, 'call.viewHistory', { defaultValue: true }),
		canManageSettings: hasChatFeaturePermission(user, 'call.manageSettings', { defaultValue: false }),
	};
}
